"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZodError = void 0;
/* istanbul ignore file */
class ZodError extends Error {
    constructor(errors) {
        super(errors.join(", "));
        Object.setPrototypeOf(this, ZodError.prototype);
    }
}
exports.ZodError = ZodError;
//# sourceMappingURL=ZodError.js.map